import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function AllChinaBuyCoupon() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="pt-20 pb-4 bg-white border-b border-stone-100">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <nav className="flex items-center gap-2 text-sm text-stone-500">
            <Link to="/" className="hover:text-stone-900 transition-colors cursor-pointer">{t('breadcrumb_home')}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-stone-900 font-medium">AllChinaBuy Coupon</span>
          </nav>
        </div>
      </div>
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-8 md:py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl border border-stone-200 p-6 md:p-10 shadow-sm">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-stone-100 rounded-full text-stone-600 mb-4">6 min read</span>
            <h1 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4">AllChinaBuy Coupon 2026: Current Discounts &amp; How to Save</h1>
            <div className="flex items-center gap-4 text-sm text-stone-500 mb-6">
              <span>{t('article_last_updated')}: August 25, 2026</span>
              <span>{t('article_author')}: AllChinaBuy Research Team</span>
            </div>

            <p className="text-stone-600 leading-relaxed mb-4">
              Looking for <strong>AllChinaBuy coupons and discount codes</strong>? This guide covers how to find, use, and maximize savings on the platform.
            </p>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">Types of AllChinaBuy Discounts</h2>
            <p className="text-stone-600 leading-relaxed mb-4">AllChinaBuy offers several types of promotional discounts throughout the year:</p>
            <ul className="space-y-2 mb-4">
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>First-time User Coupons:</strong> Discounts for new customers on their first purchase</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>Seasonal Promotions:</strong> Special discounts during holidays and shopping events</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>Referral Bonuses:</strong> Credits earned when referring friends</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>Shipping Discounts:</strong> Reduced or free shipping on qualifying orders</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>Top-up Bonuses:</strong> Extra credits when adding funds to your account</span></li>
            </ul>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">How to Use Coupons</h2>
            <div className="bg-stone-50 rounded-xl p-5 mb-4">
              <ol className="space-y-3 text-sm text-stone-600">
                <li className="flex items-start gap-2"><span className="font-bold text-stone-900">1.</span> Copy the valid coupon code from the promotions page</li>
                <li className="flex items-start gap-2"><span className="font-bold text-stone-900">2.</span> Add items to your cart on AllChinaBuy</li>
                <li className="flex items-start gap-2"><span className="font-bold text-stone-900">3.</span> Enter the coupon code at checkout</li>
                <li className="flex items-start gap-2"><span className="font-bold text-stone-900">4.</span> Verify the discount is applied before payment</li>
                <li className="flex items-start gap-2"><span className="font-bold text-stone-900">5.</span> Complete your purchase with the reduced price</li>
              </ol>
            </div>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">Money-Saving Strategies</h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              Beyond coupons, there are several ways to maximize savings on AllChinaBuy. Consolidating orders reduces per-item shipping costs, removing excess packaging decreases parcel weight, and choosing economy shipping lines can significantly cut costs.
            </p>

            <div className="mt-8 bg-stone-900 rounded-xl p-6 text-center">
              <p className="text-white mb-4">Find the best deals with AllChinaBuy Spreadsheet!</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-stone-900 rounded-lg text-sm font-medium hover:bg-stone-100 transition-colors cursor-pointer">
                AllChinaBuy Spreadsheet <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}